import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useTheme } from 'theming';
import { PrioTheme } from '../../../../../theme/types';
import { makePrioStyles } from '../../../../../theme/utils';

const useStyles = makePrioStyles((theme: PrioTheme) => ({
  root: {},
  sectionHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: `${theme.spacing.small}px ${theme.spacing.extraSmall}px`,
    borderBottom: `1px solid ${theme.colors.application.border}`,
    marginBottom: theme.spacing.regular,
  },
  sectionHeaderTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.colors.application.typography.default,
    fontSize: theme.font.fontSize.extraSmall,
    fontWeight: theme.font.fontWeight.bold,
    gap: theme.spacing.small,
  },
}));

interface PrioShareCollapsibleSectionProps {
  className?: string;
  title: string;
  count?: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const PrioShareCollapsibleSection: React.FC<
  PrioShareCollapsibleSectionProps
> = ({ className, title, count, defaultOpen = true, children }) => {
  //#region ------------------------------ Defaults
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const [open, setOpen] = useState(defaultOpen);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleToggle = () => setOpen((prev) => !prev);
  //#endregion

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.sectionHeader} onClick={handleToggle}>
        <span className={classes.sectionHeaderTitle}>
          {title}
          {count !== undefined && ` (${count})`}
        </span>
        <FontAwesomeIcon
          style={{
            color: theme.colors.application.typography.default,
          }}
          icon={['fal', open ? 'chevron-up' : 'chevron-down']}
        />
      </div>
      {open && children}
    </div>
  );
};

export default PrioShareCollapsibleSection;
